
/*!
 * Main Js File
 * Funciones varias, como el manejo del ScrollToTop, mapas, links del menu cuando es onepage
 */

window.requestAnimFrame = (function () {
    return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (callback) {
            window.setTimeout(callback, 1000 / 60);
        };
})();

(function ($) {

    "use strict";

    var ruralApp = {
        backToTopItem: $('.back-to-top'),
        smoothScrollItem: $('.smooth-scroll'),
        options: {
            isOnePage: document.body.classList.contains('one_page') ? true : false,
            isFront: location.pathname == "/" || location.pathname == "/app_dev.php/" || location.pathname == "/app_dev.php"
        }
    };

    var headerFixedHeight = $('.navbar').outerHeight(true) || 0 + 10;

    if (ruralApp.options.isFront) {
        $('body').scrollspy({ target: '#main-nav', offset: headerFixedHeight });
    }

    var scrollTo = function () {
        var elem = this;
        event.preventDefault();
        //check if rural is one page
        if (ruralApp.options.isOnePage) {
            //if its one page, check if location is home or another page
            if (ruralApp.options.isFront) {
                //if its home page, complete normal smooth scroll to an anchor
                smoothScroll(elem);
            } else {
                //if its not home page, redirect to home page anchor
                var urlPath = location.pathname.indexOf("app_dev.php") != -1 ? "/app_dev.php/" : "/";
                window.location = urlPath + elem.hash;
                return;
            }
        } else {
            //if its not one page, complete normal smooth scroll to an anchor
            smoothScroll(elem);
        }
    };

    var smoothScroll = function (elem) {
        event.preventDefault();
        if (location.pathname.replace(/^\//, '') == elem.pathname.replace(/^\//, '') && location.hostname == elem.hostname) {
            var target = $(elem.hash);
            target = target.length ? target : $('[name=' + elem.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - headerFixedHeight + 30
                }, 1000);
                return false;
            }
        }
    };

    ruralApp.init = function () {
        this.addListener();
    };

    ruralApp.addListener = function () {
        var self = this;
        window.onload = function () {
            self.smoothScrollItem.on('click', scrollTo);
        };

        this.backToTopItem.on('click', function (event) {
            smoothScroll(this);
        });

    };

    ruralApp.Flexslider = (function () {
        var _initFlex = function (elem, prop) {
            if (typeof $.flexslider === 'undefined') {
                return;
            }
            $(elem).flexslider(prop);
        }

        return {
            initFlex: function (elem, prop) {
                _initFlex(elem, prop);
            }
        }
    })();

    ruralApp.MagnificPopup = (function () {
        var _initMagnific = function (elem, prop) {
            if (typeof $.magnificPopup === 'undefined') {
                return;
            }
            $(elem).magnificPopup(prop);
        }

        return {
            initMagnific: function (elem, prop) {
                _initMagnific(elem, prop);
            }
        }
    })();

    ruralApp.Map = (function () {

        var map;

        // Config Zoom
        var zoomOut, zoomIn;

        // Markers, marker pin image, locations, center map
        var markers = [];
        var marker_image;
        var locations = [];
        var centerMap = { lat: '', long: '' };

        // Proveedores de tiles disponibles (estilos de mapa)
        var tileStyles = {
            osm: {
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
                maxZoom: 19
            },
            positron: {
                url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
                maxZoom: 20
            },
            dark: {
                url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
                maxZoom: 20
            },
            voyager: {
                url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
                maxZoom: 20
            },
            topo: {
                url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://opentopomap.org">OpenTopoMap</a>',
                maxZoom: 17
            },
            satellite: {
                url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                attribution: '&copy; <a href="https://www.esri.com/">Esri</a>',
                maxZoom: 19
            }
        };

        // Message widget
        var infoWindowHTML = '<div class=\"infowindow-content\">' +
            '<h5 class=\"infowindow-title\"> %infoTitle% </h5>' +
            '<p>%infoContent%</p></div>';

        var _getTileLayer = function (styleName) {
            var style = tileStyles[styleName] || tileStyles.osm;

            return L.tileLayer(style.url, {
                attribution: style.attribution,
                maxZoom: style.maxZoom
            });
        };

        var _initMap = function (elem, locationsLoaded) {
            var $e = $(elem);

            if ($e.length === 0 || typeof L === 'undefined') {
                return;
            }

            centerMap.lat = parseFloat($e.attr('data-map-lat') || -32.522779);
            centerMap.long = parseFloat($e.attr('data-map-long') || -55.76583500000004);

            zoomOut = parseInt($e.attr('data-map-zoom-out') || 6, 10);
            zoomIn = parseInt($e.attr('data-map-zoom-in') || 15, 10);

            marker_image = $e.attr('data-marker-image') || '/bundles/grupoiterural/img/map-marker.png';

            locations = locationsLoaded || [];

            map = L.map($e.get(0), {
                scrollWheelZoom: false
            }).setView([centerMap.lat, centerMap.long], zoomOut);

            _getTileLayer($e.attr('data-map-style') || 'osm').addTo(map);

            _createMarkers();
            setTimeout(function () {
                map.invalidateSize();
            }, 100);
        };

        var _createMarkers = function () {
            locations.forEach(function (elem) {
                var latLng = [elem[1].lat, elem[1].lng];
                var marker = L.marker(latLng, {
                    icon: L.icon({
                        iconUrl: marker_image,
                        iconSize: [32, 32],
                        iconAnchor: [16, 32],
                        popupAnchor: [0, -32]
                    })
                }).addTo(map);

                marker.bindPopup(
                    infoWindowHTML
                        .replace('%infoTitle%', elem[2].title)
                        .replace('%infoContent%', elem[2].content)
                );

                marker.on('click', function () {
                    map.setView(latLng, zoomIn);
                    marker.openPopup();
                });

                markers.push(marker);
            });
        };

        return {
          initMap: function (elem, options) {
            _initMap(elem, options);
          }
        };

    })();


    document.addEventListener('DOMContentLoaded', function () {
        //expose ruralApp globally
        window.ruralApp = ruralApp;

        ruralApp.init();

    }, false);

    $("img").unveil();

})(jQuery);

$(document).ready(function() {
    $('.openModalTab').click(function(e) {
        e.preventDefault();
        var tab = $(this).data('tab');

        $('#modal-login').modal('show');
        $('#modal-login').on('shown.bs.modal', function() {
            $('.nav-tabs a[href="#' + tab + '"]').tab('show');
        });
    });
});